export default __webpack_public_path__ + "static/media/20_1_2.fdc1e102.png";